module.exports = __webpack_public_path__ + "img/group-by-tag.88b6724e.png";